export const marketingContentData = {
  howItWorks: [
    {
      title: "1. Get invited to join.",
      description:
        "Alumni from our network of vetted residencies, fellowships, and cultural institutions can sign up with a code. Not eligible? Ask a friend who is to invite you as their +1!",
    },
    {
      title: "2. Match with an aligned peer circle.",
      description:
        "After you fill out our matching survey, we place you in a dedicated cohort with five peers we think you’ll love.",
    },
    {
      title: "3. Learn a new goal-setting method.",
      description:
        "Join video calls with your circle each week, guided by our peer-coaching curriculum.",
    },
    {
      title: "4. Make real connections, and real progress.",
      description:
        "Each Pollinator program lasts for five weeks. If you love it, join the next program cycle to continue cross-pollinating. 🐝",
    },
  ],
  fit: [
    {
      title: "Could use support with an idea, project, or deadline",
      description:
        "For example: Are you working on a new body of work, and struggling to dedicate time to it? Are you hoping to complete an application, and looking for support in the process? Pollinator can help.",
    },
    {
      title: "Want to meet peers from our network",
      description:
        "Pollinator is open to interdisciplinary practitioners who have participated in opportunities such as residencies, fellowships, or other programs at institutions from our vetted network. (See [Network](/#network)).",
    },
    {
      title: "Are comfortable learning in a collective environment",
      description:
        "Your peer circle will support your practice during weekly video calls. You’ll also work together to create community guidelines (to complement Pollinator’s agreements around confidentiality, active listening, and mutual respect).",
    },
    {
      title: "Want to learn the basics of peer coaching",
      description:
        "Peer coaching is a process where two or more people come together to support each other’s personal and/or professional development. Read more about our approach [here](https://nonprofitquarterly.org/unlocking-the-value-of-circles/).",
    },
    {
      title: "Can dedicate two hours per week to live video calls",
      description:
        "You’ll meet with your peer circle over focused video calls— for two hours a week, for five consecutive weeks. These meetings will be scheduled based on your stated availability.",
    },
    {
      title: "Are open to giving feedback on our in-development program",
      description:
        "Fall of 2025 will be our pilot. We will refine and adjust the Pollinator Program based on our participants’ insights.",
    },
  ],
  praise: [
    {
      title:
        "“We need more networks to connect us to share resources at this time.”",
      description:
        "&mdash;Wendy Woon Artist, former Edward John Noble Deputy Director for Education, MoMA",
    },
    {
      title:
        "“Pollinator is something all artist-serving organizations want to offer but struggle to pull off alone. It's an investment in all the artists [and aligned peers] we're supporting across all 40+ organizations.”",
      description: "&mdash;Blair Benjamin, Assets For Artists",
    },
    {
      title:
        "“We have been gathering artists and technologists across borders for over a decade. Finally, Pollinator can help us to connect people in small groups at scale on an international level.”",
      description: "&mdash;Mechu Rapela, Tenthaus Oslo",
    },
    {
      title:
        "“Pollinator is a great idea because it takes existing networks of fellows and says: We’ve been missing an opportunity to interconnect Fellows. What if we did this in a meaningful way?”",
      description: "&mdash;Cate Fox, Center for Cultural Innovation",
    },
    {
      title:
        "“The world doesn’t need another big tech platform; it needs pollinators— something fluid, alive, and relational. Circles foster interconnection, cross-pollination, and shared growth.”",
      description: "&mdash;Martin Pettis, YMCA",
    },
    {
      title:
        "“Pollinator is another example of what the founder has been doing for the last fifteen years - finding ways to connect people in the arts so that they can support one another. She is persistent in her dedication and vision.”",
      description:
        "&mdash;Samuel Hoi, former president of Otis College of Art and Design and Maryland Institute College of Art",
    },
  ],
  team: [
    {
      title: "Program Design",
      subheader: "Caroline Woolard + Or Zubalsky",
      description:
        "Pollinator Co-Directors Caroline Woolard and Or Zubalsky are artists, educators, and technologists who have been collaborating for 15 years. From 2008-2018, they built and maintained TradeSchool.coop, an international peer-to-peer learning platform that was used in 30 cities internationally. Caroline Woolard is the Head of Foundations at Montclair State University, is the co-founder of Art.coop, a national network of art and design cooperatives, and is the co-author of Making and Being, a book about collaborative pedagogy. Or Zubalsky is a 2025 Jerome Hill Artist Fellow, and was previously a resident at Pioneer Works, a NEW INC incubator member, and C/Change R&D Lab fellow Zubalsky and Woolard have taught for over a decade at The New School, Rhode Island School of Design, Cooper Union, the School of Visual Arts, the University of New Mexico, Bennington College, George Washington University, and the University of Hartford. Learn more about [Zubalsky](https://orzubalsky.com/) and [Woolard](https://carolinewoolard.com/) here.",
    },
    {
      title: "Engineering",
      subheader: "Minima.nyc",
      description:
        "Zubalsky and Woolard got together to build Pollinator with a team of aligned engineers in 2024. The team at Minima has worked together since 2014 to deliver cutting-edge software-based solutions for corporate clients. Minima has built and managed widely used web, mobile, and server-side applications, including Apple's Music TV. Minima builds complex systems that scale, are maintainable, and cost effective. Minima prioritizes the end user across axes of accessibility, security, communication, and simplicity.",
    },
    {
      title: "Creative Director",
      description: "Caroline Woolard",
    },
    {
      title: "Creative Operations",
      description: "Or Zubalsky",
    },
    {
      title: "Outreach + Operations",
      description: "Isaiah Madison",
    },
    {
      title: "Branding",
      description: "Topos Graphics",
    },
    {
      title: "Design",
      description: "Or Zubalsky",
    },
    {
      title: "Copywriting",
      description: "Willa Köerner",
    },
    {
      title: "Pedagogy",
      description: "Caroline Woolard + Belén Santillán",
    },
    {
      title: "Repair",
      description: "Martin Pettis",
    },
    {
      title: "Special Projects",
      description: "Mechu Rapela + Shahrzad Malekian + Ida Uvaas",
    },
  ],
  advisors: [
    {
      title: "Oihane Amurrio",
      description: "Lead Program Developer, Mondragon Team Academy",
    },
    {
      title: "Ted Berger",
      description:
        "Executive Director Emeritus of the New York Foundation for the Arts",
    },
    {
      title: "Sarah Calderon",
      description: "Founding Executive Director, Creatives Rebuild New York",
    },
    {
      title: "Pablo Helguera",
      description: "Artist + Educator",
    },
    {
      title: "Sophie Landres",
      description: "Curator",
    },
    {
      title: "Ruby Lerner",
      description: "Founding Director, Creative Capital",
    },
    {
      title: "Sofía Olascoaga",
      description: "Curator + Educator",
    },
    {
      title: "Martin Pettis",
      description: "Executive Director, WE CARE Therapies",
    },
    {
      title: "Nathan Schneider",
      description: "University of Colorado",
    },
    {
      title: "Jean Shin",
      description: "Artist + Educator",
    },
    {
      title: "Gesyada Annisa Namora Siregar",
      description: "Curator",
    },
    {
      title: "Wendy Woon",
      description:
        "Artist, former Edward John Noble Deputy Director for Education, MoMA",
    },
  ],
};

export const marketingNavigationItemsData = [
  { title: "Program", href: "/#program" },
  { title: "How It Works", href: "/#how-it-works" },
  { title: "Team", href: "/#team" },
  { title: "Vision", href: "/#vision" },
  { title: "Donate", href: "/#donate" },
];

export const marketingSendingInstitutionsData = [
  { name: "32° East", location: "Uganda", isActive: true },
  { name: "A Blade of Grass", location: "US" },
  { name: "ACRE", location: "US" },
  { name: "AFIELD", location: "France", isActive: true },
  { name: "AICAD", location: "US" },
  { name: "Ajaibghar", location: "India" },
  { name: "Art + Critique", location: "England" },
  { name: "Art in Odd Places", location: "US" },
  { name: "Art Omi", location: "US", isActive: true },
  { name: "Artadia", location: "US" },
  { name: "Artists Thrive", location: "US" },
  { name: "Arts University Plymouth", location: "UK" },
  { name: "Assets for Artists", location: "US" },
  {
    name: "ATNSC: Center for Healing and Creative Leadership",
    location: "US",
  },
  { name: "at Louis Place", location: "US" },
  { name: "BAXTER ST", location: "US" },
  { name: "Blockbusters", location: "US" },
  { name: "BRUJAS", location: "US" },
  { name: "Buena Onda", location: "US" },
  { name: "California College of the Arts", location: "US" },
  { name: "CEC ArtsLink", location: "International", isActive: true },
  { name: "Charlotte Street", location: "US" },
  { name: "CIRCA art actuel", location: "Canada" },
  { name: "Concordia University", location: "Canada" },
  { name: "Cooper Union", location: "US" },
  { name: "Core Residency Program", location: "US", isActive: true },
  { name: "CREA", location: "US" },
  { name: "Creative Wildfire", location: "US" },
  { name: "Culture Push", location: "US" },
  { name: "DisCO", location: "Spain" },
  { name: "EAT: Economics. Art. Transformation", location: "US" },
  { name: "EGD Collective", location: "US" },
  { name: "Foundation for Contemporary Arts", location: "US", isActive: true },
  { name: "Franklin Furnace", location: "US" },
  { name: "Flux Factory", location: "US" },
  { name: "Fractured Atlas", location: "US" },
  { name: "Grand Central Art Center", location: "US" },
  { name: "Gudskul", location: "Indonesia", isActive: true },
  { name: "Hayama Artist Residency", location: "Japan", isActive: true },
  { name: "Headlands", location: "US" },
  { name: "IndieSpace", location: "US" },
  {
    name: "Interdisciplinary Art and Theory Program",
    location: "US",
    isActive: true,
  },
  { name: "Interlude Artist Residency", location: "US" },
  { name: "Invest in Open", location: "US" },
  { name: "Jerome Foundation", location: "US", isActive: true },
  { name: "Just Tech Fellowship", location: "US" },
  { name: "Kansas City Art Institute", location: "US" },
  { name: "Latitude Chicago", location: "US" },
  { name: "Laundromat Project", location: "US", isActive: true },
  { name: "Level Ground", location: "US" },
  { name: "LIFT Economy", location: "US" },
  { name: "Luleå Biennale", location: "Sábme" },
  { name: "MacDowell", location: "US", isActive: true },
  { name: "Malmo Art Academy", location: "Sweden" },
  { name: "Map Fund", location: "US", isActive: true },
  { name: "MdW Coalition", location: "US" },
  { name: "Media Economies Design Lab", location: "US" },
  //{ name: "Metalabel", location: "US" },
  { name: "Miriam Gallery", location: "US" },
  { name: "Minneapolis College of Art and Design", location: "US" },
  { name: "More Art", location: "US" },
  { name: "National Performance Network", location: "US", isActive: true },
  { name: "NEW INC", location: "US", isActive: true },
  { name: "Nongki NYC", location: "US" },
  { name: "Ox-Bow School of Art & Artists' Residency", location: "US" },
  { name: "Photography + Media & Society MFA @ MICA", location: "US" },
  { name: "Pioneer Works", location: "US" },
  { name: "Processing Foundation", location: "US", isActive: true },
  { name: "Queer Metalsmiths", location: "US" },
  { name: "Queer.Archive.Work.", location: "US" },
  { name: "Rensselaer Polytechnic Institute", location: "US" },
  { name: "RISD", location: "US" },
  { name: "Rutgers", location: "US" },
  { name: "SAVVY Contemporary", location: "Germany" },
  { name: "School of Commons", location: "Switzerland" },
  { name: "Set Margins' Publications", location: "Netherlands" },
  { name: "Skowhegan", location: "US", isActive: true },
  { name: "Small School", location: "US" },
  { name: "Soft Network", location: "US" },
  { name: "SpOnAcT!", location: "Taiwan" },
  { name: "Studios at MASS MoCA", location: "US" },
  { name: "Tenthaus Art Collective", location: "Norway" },
  { name: "The Bronx Museum", location: "US", isActive: true },
  { name: "The Oxbow School", location: "US" },
  { name: "The Rebellious Root Collective", location: "US" },
  { name: "The Strange Foundation", location: "US" },
  { name: "Travelling University", location: "Spain, Germany, South Korea" },
  { name: "Tributary Projects", location: "Australia" },
  { name: "UCLA - Department of Design | Media Arts", location: "US" },
  { name: "University of Applied Arts Vienna", location: "Austria" },
  { name: "University of North Carolina", location: "US" },
  { name: "Void Art Centre", location: "UK" },
  { name: "Vox Populi", location: "US" },
  { name: "Wave Farm", location: "US" },
  { name: "Wave Pool", location: "US" },
];

export default marketingContentData;
